var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              on: { click: _setup.handleCreateDatasetCommandV1 },
            },
            [_vm._v("Create dataset")]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_setup.datasets, function (d) {
        return _c("div", { key: d.DatasetId }, [
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/datasets/details/${d.DatasetId}`,
              },
            },
            [_vm._v(_vm._s(d.Name))]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-7" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
          },
        },
        [_vm._v("Manage datasets")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }